/**
 * Texto de partida de una plantilla de recompra nueva, por idioma. Solo se usa si el
 * backend no devuelve `contentExample` para POST_PURCHASE (no hay TemplateVariables
 * sembradas para este flowType). Texto plano, como lo guarda el backend:
 * TemplateContentAdapter lo pasa al editor.
 *
 * Ninguna variable va al principio ni al final: Meta rechaza esas plantillas
 * (ver utils/templateValidation).
 */
const DEFAULT_TEMPLATES = {
    es:
        '¡Hola {{customer_name}}! Soy {{agent_name}} de {{shop_name}}.\n\n' +
        'Hace unos días te llegó tu pedido {{order_number}}. ¿Qué tal con {{product_list}}?\n\n' +
        'Si quieres repetir o te apetece probar algo nuevo, respóndeme por aquí y te ayudo.',

    en:
        'Hi {{customer_name}}! This is {{agent_name}} from {{shop_name}}.\n\n' +
        'Your order {{order_number}} arrived a few days ago. How are you getting on with {{product_list}}?\n\n' +
        "If you'd like to order again or try something new, just reply here and I'll help you.",

    fr:
        'Bonjour {{customer_name}} ! Je suis {{agent_name}} de {{shop_name}}.\n\n' +
        'Votre commande {{order_number}} est arrivée il y a quelques jours. Que pensez-vous de {{product_list}} ?\n\n' +
        'Si vous souhaitez commander à nouveau ou découvrir autre chose, répondez-moi ici et je vous aiderai.',

    it:
        'Ciao {{customer_name}}! Sono {{agent_name}} di {{shop_name}}.\n\n' +
        "Qualche giorno fa ti è arrivato l'ordine {{order_number}}. Come ti trovi con {{product_list}}?\n\n" +
        'Se vuoi riordinare o provare qualcosa di nuovo, rispondimi qui e ti aiuto.',

    de:
        'Hallo {{customer_name}}! Hier ist {{agent_name}} von {{shop_name}}.\n\n' +
        'Deine Bestellung {{order_number}} ist vor ein paar Tagen angekommen. Wie gefällt dir {{product_list}}?\n\n' +
        'Wenn du nachbestellen oder etwas Neues ausprobieren möchtest, antworte einfach hier und ich helfe dir.',

    pt:
        'Olá {{customer_name}}! Sou {{agent_name}} da {{shop_name}}.\n\n' +
        'A sua encomenda {{order_number}} chegou há alguns dias. O que achou de {{product_list}}?\n\n' +
        'Se quiser voltar a comprar ou experimentar algo novo, responda-me aqui e eu ajudo.',
};

/**
 * @param {string} languageTag Etiqueta de idioma (`es_AR`, `en_US`, `fr`…).
 * @returns {string} Cuerpo de la plantilla, con respaldo al idioma base y luego a inglés.
 */
export const getDefaultPostPurchaseTemplate = (languageTag) => {
    if (!languageTag) return DEFAULT_TEMPLATES.en;
    const exact = languageTag.toLowerCase().replace('-', '_');
    const base = exact.split('_')[0];

    return DEFAULT_TEMPLATES[exact] || DEFAULT_TEMPLATES[base] || DEFAULT_TEMPLATES.en;
};
